import functions from "./functions";

function quantityChange(buttonElement) {

    let qty = buttonElement.closest('[data-quantity]').find('[data-quantity-input]');
    let val = parseFloat(qty.val());
    let max = parseFloat(qty.attr('max'));
    let min = parseFloat(qty.attr('min'));
    let step = parseFloat(qty.attr('step'));

    if (buttonElement.val() === "+") {

        buttonElement.siblings('[data-quantity-down]').removeClass('disabled');


        if (max && (max <= val)) {

            qty.val(max);

        } else {

            qty.val(val + step);

        }


    } else {

        if (val <= 2) {

            buttonElement.addClass('disabled');
        }

        if (min && (min >= val)) {

            qty.val(min);

        } else if (val > 1) {

            qty.val(val - step);

        }

    }

}

function triggerUpdate() {
    if (functions.checkPage('cart')) {
        $(':input[name="update_cart"]').prop('disabled', false).attr('aria-disabled', false).trigger('click');
    }
}

function init() {
    let delayTimer;
    //variationToggleActive();
    $('[data-quantity-input]').on('blur', () => {
        if (this.value !== this.defaultValue) {
            console.log(this.defaultValue, this.value);
            $('.woocommerce-cart-form .cart_item :input').trigger('change');
        }
    });

    $('body').on('click', '[data-quantity-up], [data-quantity-down]', function (e) {
        clearTimeout(delayTimer);
        let button = $(this);

        if (!$(this).hasClass('disabled')) {
            quantityChange(button);

            delayTimer = setTimeout(() => {
                triggerUpdate();
            }, 500);
        }
    });



}

export default {init, quantityChange};